<template>
  <div class="acordos-page">

    <!-- ── SEÇÃO: Lista ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-handshake-outline</v-icon>
        </div>
        <div class="form-section__heading">
          <div class="form-section__title">Configurações de Acordo</div>
          <div class="form-section__sub">Regras de negociação disponíveis para o consumidor</div>
        </div>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Buscar acordo"
          outlined dense color="#0052A0"
          hide-details clearable
          style="max-width:260px"
          class="mr-3 acordos-busca"
        />
        <v-btn color="#0052A0" rounded elevation="0" @click="abrirModalNovo" class="px-5">
          <v-icon left color="#FFD400" small>mdi-plus</v-icon>
          <span style="color:#FFD400;font-weight:700;font-size:13px">Novo</span>
        </v-btn>
      </div>
    </div>

    <!-- ── SEÇÃO: Tabela ── -->
    <div class="form-section form-section--last">
      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        class="acordos-table elevation-0"
        no-data-text="Sem dados"
        :footer-props="{
          'items-per-page-text': 'Registros por página: ',
          'page-text': '{0}-{1} de {2}',
          'items-per-page-all-text': 'Listar todos',
        }"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td style="max-width:200px;font-weight:600">{{ item.nome_regra }}</td>
            <td class="text-res">{{ item.descricao }}</td>
            <td>{{ converterDataTimestamp(item.data_vigiencia) }}</td>
            <td>{{ converterDataTimestamp(item.data_final_vigiencia) }}</td>
            <td>
              <v-chip x-small label
                :color="item.permite_negociacao_agrupada ? '#dbeafe' : '#f1f5f9'"
                :text-color="item.permite_negociacao_agrupada ? '#1d4ed8' : '#64748b'"
                style="font-family:'Inter',sans-serif;font-weight:600;"
              >
                <v-icon x-small left>{{ item.permite_negociacao_agrupada ? 'mdi-check' : 'mdi-minus' }}</v-icon>
                {{ item.permite_negociacao_agrupada ? 'Sim' : 'Não' }}
              </v-chip>
            </td>
            <!-- Elegibilidade resumida -->
            <td>
              <span v-if="item.elegibilidade" class="eleg-chip-wrap">
                <v-chip x-small label color="#f0fdf4" text-color="#16a34a"
                  style="font-family:'Inter',sans-serif;font-weight:600;max-width:220px;"
                  :title="elegibilidadeResumo(item.elegibilidade)"
                >
                  <v-icon x-small left>mdi-filter-check-outline</v-icon>
                  {{ elegibilidadeResumo(item.elegibilidade) }}
                </v-chip>
              </span>
              <span v-else style="font-size:0.78rem;color:#94a3b8">—</span>
            </td>
            <!-- Prioridade -->
            <td class="text-center">
              <v-chip x-small label
                :color="(item.prioridade || 0) > 0 ? '#eff6ff' : '#f8fafc'"
                :text-color="(item.prioridade || 0) > 0 ? '#1d4ed8' : '#94a3b8'"
                style="font-family:'Inter',sans-serif;font-weight:700;min-width:32px;justify-content:center;"
              >{{ item.prioridade || 0 }}</v-chip>
            </td>
            <td>
              <v-btn icon small color="#0052A0" @click="abrirModalVer(item)" title="Visualizar">
                <v-icon small>mdi-card-bulleted-settings-outline</v-icon>
              </v-btn>
              <v-btn icon small color="#0052A0" @click="abrirModalEditar(item)" title="Editar">
                <v-icon small>mdi-square-edit-outline</v-icon>
              </v-btn>
              <v-btn icon small color="error" @click="abrirModalInativar(item)" title="Excluir">
                <v-icon small>mdi-delete-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <!-- ══ MODAL: Cadastro / Edição ══ -->
    <v-dialog v-model="dialog" persistent max-width="900px" scrollable>
      <v-card elevation="0">
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0">mdi-handshake-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">{{ modal.title }}</div>
            <div class="dialog-header__sub">Parâmetros da regra de negociação</div>
          </div>
          <v-spacer />
          <v-btn icon @click="dialog = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>

        <!-- Abas -->
        <v-tabs v-model="abaAtiva" color="#0052A0" background-color="#f8fafc"
          slider-color="#0052A0" class="acordos-tabs">
          <v-tab class="tab-label">
            <v-icon small left>mdi-currency-usd</v-icon>Condições Financeiras
          </v-tab>
          <v-tab class="tab-label">
            <v-icon small left>mdi-filter-outline</v-icon>Elegibilidade de Títulos
          </v-tab>
          <v-tab class="tab-label">
            <v-icon small left>mdi-clock-outline</v-icon>Disponibilidade e Canal
          </v-tab>
        </v-tabs>

        <v-card-text class="pa-6">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-tabs-items v-model="abaAtiva">

              <!-- ═══ ABA 1: Condições Financeiras ═══ -->
              <v-tab-item>

                <!-- Identificação -->
                <div class="dialog-section-label mt-2">Identificação</div>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Nome da campanha"
                      :rules="vazio"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      v-model="hand.nome_regra"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <data-component
                      v-model="hand.data_vigiencia"
                      labelDate="Início Vigência"
                      :minimodata="dataHoje"
                      only-date outlined dense color="#0052A0"
                      :datas="hand.data_vigiencia"
                    />
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.prioridade"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      label="Prioridade"
                      hint="Maior = vence"
                      persistent-hint
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      label="Descrição da campanha"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      v-model="hand.descricao"
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <data-component
                      v-model="hand.data_final_vigiencia"
                      labelDate="Data Final de Vigência"
                      :minimodata="dataHoje"
                      only-date outlined dense color="#0052A0"
                      :datas="hand.data_final_vigiencia"
                      @emit-data="getDataFinal"
                    />
                  </v-col>
                </v-row>

                <!-- Condições financeiras -->
                <div class="dialog-section-label mt-4">Condições Financeiras</div>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.desconto_avista"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      suffix="%" label="Desc. à vista"
                      :rules="[(v) => (v >= 0 && v <= 100 && !!v) || 'Número inválido']"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.porc_entrada"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      suffix="%" label="Perc. entrada"
                      :rules="[(v) => (v >= 0 && v <= 100 && !!v) || 'Valor inválido']"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.juros"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      suffix="%" label="Juros"
                      :rules="[(v) => (v >= 0 && v <= 100 && !!v) || 'Número inválido']"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.multa"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      suffix="%" label="Multa"
                      :rules="[(v) => (v >= 0 && v <= 100 && !!v) || 'Número inválido']"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-bind:items="indices_monetarios"
                      v-model="hand.indicemonetario_id"
                      label="Índice Monetário"
                      outlined dense color="#0052A0"
                      item-value="id"
                      :readonly="isReadOnly"
                    >
                      <template slot="item" scope="data">{{ data.item.descricao }}</template>
                      <template slot="selection" scope="data">{{ data.item.descricao }}</template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field-money
                      :readonly="isReadOnly"
                      v-model="hand.outros"
                      label="Valor Outros"
                      v-bind:properties="{
                        prefix: 'R$',
                        outlined: true,
                        dense: true,
                        clearable: true,
                        placeholder: ' ',
                        rules: [(v) => !!v || 'Este item é obrigatório'],
                        color: '#0052A0',
                      }"
                      v-bind:options="{
                        locale: 'pt-BR',
                        length: 11,
                        precision: 2,
                        empty: null,
                      }"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Descrição outros"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      v-model="hand.descricao_outros"
                    />
                  </v-col>
                </v-row>

                <!-- Parcelamento -->
                <div class="dialog-section-label mt-4">Parcelamento</div>
                <v-row dense align="center">
                  <v-col cols="12" md="3" class="d-flex align-center">
                    <v-checkbox
                      v-model="hand.pagamento_parcelado"
                      :readonly="isReadOnly"
                      color="#0052A0"
                      label="Permite Parcelar"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="3" v-if="hand.pagamento_parcelado">
                    <v-text-field
                      type="number" :min="1"
                      v-model="hand.qtd_parcelas"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      :rules="[(v) => v >= 1 || 'Número inválido']"
                      label="Qtd. de parcelas"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.qtd_dias"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      :rules="[(v) => v >= 0 || 'Número inválido']"
                      label="Qtd. dias"
                    />
                  </v-col>
                  <v-col cols="12" md="3" class="d-flex align-center">
                    <v-checkbox
                      v-model="hand.tipo_baixa"
                      :readonly="isReadOnly"
                      color="#0052A0"
                      label="Baixa na primeira parcela"
                      hide-details
                    />
                  </v-col>
                </v-row>

                <!-- Disponibilidade para o consumidor -->
                <div class="dialog-section-label mt-4">Disponibilidade para o Consumidor</div>
                <v-row dense>
                  <v-col cols="12">
                    <v-card outlined class="negociacao-agrupada-card pa-4">
                      <div class="d-flex align-center" style="gap:16px">
                        <div class="negociacao-agrupada-icon">
                          <v-icon color="#0052A0" size="22">mdi-account-group-outline</v-icon>
                        </div>
                        <div style="flex:1">
                          <div style="font-family:'Inter',sans-serif;font-size:0.88rem;font-weight:600;color:#1e293b">
                            Permitir negociação agrupada
                          </div>
                          <div style="font-family:'Inter',sans-serif;font-size:0.78rem;color:#64748b;margin-top:2px">
                            Permite que o consumidor negocie múltiplas dívidas do mesmo credor em um único acordo
                          </div>
                        </div>
                        <v-switch
                          v-model="hand.permite_negociacao_agrupada"
                          :readonly="isReadOnly"
                          color="#0052A0"
                          hide-details inset
                          class="mt-0 pt-0"
                        />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

              </v-tab-item>

              <!-- ═══ ABA 2: Elegibilidade de Títulos ═══ -->
              <v-tab-item>

                <!-- Geográfico -->
                <div class="dialog-section-label mt-2">Geográfico</div>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="hand.elegibilidade.ufs_elegiveis"
                      :items="ufs"
                      label="UFs elegíveis"
                      multiple chips small-chips deletable-chips
                      outlined dense color="#0052A0"
                      :readonly="isReadOnly"
                      clearable
                      hint="Vazio = todos os estados"
                      persistent-hint
                    />
                  </v-col>
                </v-row>

                <!-- Valor -->
                <div class="dialog-section-label mt-4">Faixa de Valor do Título</div>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <v-text-field-money
                      :readonly="isReadOnly"
                      v-model="hand.elegibilidade.valor_minimo"
                      label="Valor mínimo"
                      v-bind:properties="{
                        prefix: 'R$', outlined: true, dense: true,
                        clearable: true, placeholder: ' ', color: '#0052A0',
                        hint: 'Nulo = sem limite mínimo', persistentHint: true,
                      }"
                      v-bind:options="{ locale: 'pt-BR', length: 13, precision: 2, empty: null }"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field-money
                      :readonly="isReadOnly"
                      v-model="hand.elegibilidade.valor_maximo"
                      label="Valor máximo"
                      v-bind:properties="{
                        prefix: 'R$', outlined: true, dense: true,
                        clearable: true, placeholder: ' ', color: '#0052A0',
                        hint: 'Nulo = sem limite máximo', persistentHint: true,
                      }"
                      v-bind:options="{ locale: 'pt-BR', length: 13, precision: 2, empty: null }"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field-money
                      :readonly="isReadOnly"
                      v-model="hand.elegibilidade.valor_total_maximo_agrupado"
                      label="Total máx. agrupado"
                      v-bind:properties="{
                        prefix: 'R$', outlined: true, dense: true,
                        clearable: true, placeholder: ' ', color: '#0052A0',
                        hint: 'Nulo = ilimitado', persistentHint: true,
                      }"
                      v-bind:options="{ locale: 'pt-BR', length: 13, precision: 2, empty: null }"
                    />
                  </v-col>
                </v-row>

                <!-- Dias em atraso -->
                <div class="dialog-section-label mt-4">Dias em Atraso</div>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.elegibilidade.dias_atraso_min"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      label="Mínimo de dias"
                      hint="Nulo = sem limite" persistent-hint
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="0"
                      v-model="hand.elegibilidade.dias_atraso_max"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      label="Máximo de dias"
                      hint="Nulo = sem limite" persistent-hint
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      type="number" :min="1"
                      v-model="hand.elegibilidade.max_titulos_por_acordo"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      label="Máx. títulos/acordo"
                      hint="Nulo = ilimitado" persistent-hint
                      clearable
                    />
                  </v-col>
                </v-row>

                <!-- Range de datas -->
                <div class="dialog-section-label mt-4">Range de Datas do Título</div>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <data-component
                      v-model="hand.elegibilidade.data_vencimento_de"
                      labelDate="Vencimento de"
                      only-date outlined dense color="#0052A0"
                      :datas="hand.elegibilidade.data_vencimento_de"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <data-component
                      v-model="hand.elegibilidade.data_vencimento_ate"
                      labelDate="Vencimento até"
                      only-date outlined dense color="#0052A0"
                      :datas="hand.elegibilidade.data_vencimento_ate"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <data-component
                      v-model="hand.elegibilidade.data_emissao_de"
                      labelDate="Emissão de"
                      only-date outlined dense color="#0052A0"
                      :datas="hand.elegibilidade.data_emissao_de"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <data-component
                      v-model="hand.elegibilidade.data_emissao_ate"
                      labelDate="Emissão até"
                      only-date outlined dense color="#0052A0"
                      :datas="hand.elegibilidade.data_emissao_ate"
                    />
                  </v-col>
                </v-row>

                <!-- Exclusões -->
                <div class="dialog-section-label mt-4">Exclusões Automáticas</div>
                <v-row dense>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <v-checkbox
                      v-model="hand.elegibilidade.excluir_em_acordo"
                      :readonly="isReadOnly"
                      color="#0052A0"
                      label="Excluir títulos já em acordo"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <v-checkbox
                      v-model="hand.elegibilidade.excluir_em_judicial"
                      :readonly="isReadOnly"
                      color="#0052A0"
                      label="Excluir títulos em judicial"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <v-checkbox
                      v-model="hand.elegibilidade.excluir_com_contestacao"
                      :readonly="isReadOnly"
                      color="#0052A0"
                      label="Excluir com contestação aberta"
                      hide-details
                    />
                  </v-col>
                </v-row>

                <!-- Consumidor -->
                <div class="dialog-section-label mt-4">Exigências do Consumidor</div>
                <v-row dense align="center">
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <v-checkbox
                      v-model="hand.elegibilidade.exigir_cpf_validado"
                      :readonly="isReadOnly"
                      color="#0052A0"
                      label="Exigir CPF validado"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex align-center">
                    <v-checkbox
                      v-model="hand.elegibilidade.exigir_email_verificado"
                      :readonly="isReadOnly"
                      color="#0052A0"
                      label="Exigir e-mail verificado"
                      hide-details
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      type="number" :min="1"
                      v-model="hand.elegibilidade.max_acordos_ativos_por_consumidor"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      label="Máx. acordos ativos/consumidor"
                      hint="Nulo = ilimitado" persistent-hint
                      clearable
                    />
                  </v-col>
                </v-row>

              </v-tab-item>

              <!-- ═══ ABA 3: Disponibilidade e Canal ═══ -->
              <v-tab-item>

                <!-- Canais -->
                <div class="dialog-section-label mt-2">Canais de Atendimento</div>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <v-card outlined class="canal-card pa-3">
                      <div class="d-flex align-center" style="gap:12px">
                        <v-icon color="#0052A0">mdi-monitor-outline</v-icon>
                        <div style="flex:1;font-family:'Inter',sans-serif;font-size:0.85rem;font-weight:600;color:#1e293b">Portal Web</div>
                        <v-switch v-model="hand.elegibilidade.canal_web" :readonly="isReadOnly"
                          color="#0052A0" hide-details inset class="mt-0 pt-0" />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card outlined class="canal-card pa-3">
                      <div class="d-flex align-center" style="gap:12px">
                        <v-icon color="#0052A0">mdi-cellphone-outline</v-icon>
                        <div style="flex:1;font-family:'Inter',sans-serif;font-size:0.85rem;font-weight:600;color:#1e293b">App Mobile</div>
                        <v-switch v-model="hand.elegibilidade.canal_mobile" :readonly="isReadOnly"
                          color="#0052A0" hide-details inset class="mt-0 pt-0" />
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-card outlined class="canal-card pa-3">
                      <div class="d-flex align-center" style="gap:12px">
                        <v-icon color="#25D366">mdi-whatsapp</v-icon>
                        <div style="flex:1;font-family:'Inter',sans-serif;font-size:0.85rem;font-weight:600;color:#1e293b">WhatsApp</div>
                        <v-switch v-model="hand.elegibilidade.canal_whatsapp" :readonly="isReadOnly"
                          color="#25D366" hide-details inset class="mt-0 pt-0" />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Janela de atendimento -->
                <div class="dialog-section-label mt-4">Janela de Atendimento</div>
                <v-row dense>
                  <v-col cols="12">
                    <v-select
                      v-model="hand.elegibilidade.dias_semana"
                      :items="diasSemanaOpcoes"
                      item-value="value"
                      item-text="label"
                      label="Dias da semana"
                      multiple chips small-chips deletable-chips
                      outlined dense color="#0052A0"
                      :readonly="isReadOnly"
                      clearable
                      hint="Vazio = todos os dias" persistent-hint
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="hand.elegibilidade.hora_inicio"
                      type="time"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      label="Hora início"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="hand.elegibilidade.hora_fim"
                      type="time"
                      :readonly="isReadOnly"
                      outlined dense color="#0052A0"
                      label="Hora fim"
                      clearable
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-select
                      v-model="hand.elegibilidade.fuso_horario"
                      :items="fusosOpcoes"
                      label="Fuso horário"
                      outlined dense color="#0052A0"
                      :readonly="isReadOnly"
                    />
                  </v-col>
                </v-row>

                <!-- Ativo -->
                <div class="dialog-section-label mt-4">Status da Elegibilidade</div>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-card outlined class="negociacao-agrupada-card pa-4">
                      <div class="d-flex align-center" style="gap:16px">
                        <div class="negociacao-agrupada-icon">
                          <v-icon color="#0052A0" size="22">mdi-toggle-switch-outline</v-icon>
                        </div>
                        <div style="flex:1">
                          <div style="font-family:'Inter',sans-serif;font-size:0.88rem;font-weight:600;color:#1e293b">
                            Elegibilidade ativa
                          </div>
                          <div style="font-family:'Inter',sans-serif;font-size:0.78rem;color:#64748b;margin-top:2px">
                            Desativar mantém os dados mas remove a filtragem
                          </div>
                        </div>
                        <v-switch
                          v-model="hand.elegibilidade.ativo"
                          :readonly="isReadOnly"
                          color="#0052A0"
                          hide-details inset
                          class="mt-0 pt-0"
                        />
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

              </v-tab-item>

            </v-tabs-items>
          </v-form>
        </v-card-text>

        <v-card-actions class="pa-4 pt-0">
          <v-spacer />
          <v-btn text rounded color="#64748b" @click="dialog = false" class="px-5">Cancelar</v-btn>
          <v-btn
            v-if="isReadOnly"
            outlined rounded color="#0052A0"
            @click="isReadOnly = false"
            class="px-5"
          >
            <v-icon left small>mdi-pencil-outline</v-icon>
            Editar
          </v-btn>
          <v-btn
            v-if="!isReadOnly"
            color="#0052A0" rounded elevation="0"
            :loading="carregando"
            :disabled="!valid"
            @click="validate"
            class="px-6"
          >
            <v-icon left color="#FFD400" small>mdi-content-save-outline</v-icon>
            <span style="color:#FFD400;font-weight:700;font-size:13px">Salvar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ══ MODAL: Excluir ══ -->
    <v-dialog v-model="modalDelete" persistent max-width="420px">
      <v-card elevation="0">
        <div class="dialog-header dialog-header--danger">
          <div class="dialog-header__icon-wrap dialog-header__icon-wrap--danger">
            <v-icon color="#dc2626">mdi-delete-alert-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Excluir Configuração</div>
            <div class="dialog-header__sub">{{ hand.nome_regra }}</div>
          </div>
          <v-spacer />
          <v-btn icon @click="modalDelete = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6">
          <p style="font-family:'Inter',sans-serif;color:#475569;font-size:0.9rem;">
            Tem certeza que deseja excluir esta configuração de acordo? Esta ação não pode ser desfeita.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer />
          <v-btn text rounded color="#64748b" @click="modalDelete = false" class="px-5">Cancelar</v-btn>
          <v-btn outlined rounded color="error" :loading="carregando" @click="inativarConf()" class="px-5">
            <v-icon left small>mdi-delete-outline</v-icon>
            Excluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import helper from "../../../mixins/helper";
import DataComponent from "../../../components/DataComponent";

const elegibilidadeVazia = () => ({
  ufs_elegiveis:                    null,
  municipios_elegiveis:             null,
  valor_minimo:                     null,
  valor_maximo:                     null,
  valor_total_maximo_agrupado:      null,
  dias_atraso_min:                  null,
  dias_atraso_max:                  null,
  data_vencimento_de:               null,
  data_vencimento_ate:              null,
  data_emissao_de:                  null,
  data_emissao_ate:                 null,
  especies_elegiveis:               null,
  excluir_em_acordo:                true,
  excluir_em_judicial:              true,
  excluir_com_contestacao:          true,
  max_titulos_por_acordo:           null,
  canal_web:                        true,
  canal_mobile:                     true,
  canal_whatsapp:                   false,
  dias_semana:                      null,
  hora_inicio:                      null,
  hora_fim:                         null,
  fuso_horario:                     'America/Sao_Paulo',
  exigir_cpf_validado:              false,
  exigir_email_verificado:          false,
  max_acordos_ativos_por_consumidor: null,
  ativo:                            true,
});

export default {
  components: { DataComponent },
  mixins: [helper],
  data: () => ({
    dataHoje: null,
    dialog: false,
    modalDelete: false,
    carregando: false,
    valid: false,
    abaAtiva: 0,
    modal: { title: null, type: null },
    isReadOnly: false,
    vazio: [(v) => !!v || "O campo não pode estar vazio"],
    hand: {
      nome_regra: null,
      empresa_id: null,
      data_vigiencia: null,
      descricao: null,
      pagamento_parcelado: null,
      qtd_parcelas: null,
      desconto_avista: null,
      porc_entrada: null,
      qtd_dias: null,
      tipo_baixa: null,
      juros: null,
      indicemonetario_id: null,
      multa: null,
      indice_monetaria: null,
      type_valor_honorario: null,
      valor_honorario: null,
      type_outros: null,
      outros: null,
      descricao_outros: null,
      data_final_vigiencia: null,
      permite_negociacao_agrupada: false,
      prioridade: 0,
      elegibilidade: elegibilidadeVazia(),
    },
    list: [],
    indices_monetarios: [],
    search: "",
    headers: [
      { text: "Nome",              value: "nome_regra",                   align: "start" },
      { text: "Descrição",         value: "descricao",                    align: "start" },
      { text: "Início Vigência",   value: "data_vigiencia",               align: "start", width: "11%" },
      { text: "Fim Vigência",      value: "data_final_vigiencia",         align: "start", width: "11%" },
      { text: "Neg. Agrupada",     value: "permite_negociacao_agrupada",  align: "center", width: "100px" },
      { text: "Elegibilidade",     value: "elegibilidade",                align: "start",  width: "200px", sortable: false },
      { text: "Prioridade",        value: "prioridade",                   align: "center", width: "90px" },
      { text: "Ações",             value: "",                             align: "center", width: "12%", sortable: false },
    ],
    type: [
      { name: "Porcentagem", value: 0 },
      { name: "Dinheiro",    value: 1 },
    ],
    ufs: [
      'AC','AL','AM','AP','BA','CE','DF','ES','GO','MA',
      'MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN',
      'RO','RR','RS','SC','SE','SP','TO',
    ],
    diasSemanaOpcoes: [
      { value: 0, label: 'Domingo' },
      { value: 1, label: 'Segunda' },
      { value: 2, label: 'Terça'   },
      { value: 3, label: 'Quarta'  },
      { value: 4, label: 'Quinta'  },
      { value: 5, label: 'Sexta'   },
      { value: 6, label: 'Sábado'  },
    ],
    fusosOpcoes: [
      'America/Sao_Paulo',
      'America/Manaus',
      'America/Belem',
      'America/Fortaleza',
      'America/Recife',
      'America/Noronha',
    ],
  }),
  mounted() {
    this.dataHoje = new Date().toISOString().split("T")[0];
    this.getIndicesMonetarios();
    this.getAcordos();
  },
  methods: {
    notificacao(title, msg, icon) {
      this.$swal({
        toast: true, position: "top-center",
        showConfirmButton: false, timer: 3000,
        icon, title, text: msg,
      });
    },
    limparForm() {
      this.hand = {
        nome_regra: null, empresa_id: null, data_vigiencia: null,
        descricao: null, pagamento_parcelado: null, qtd_parcelas: null,
        desconto_avista: null, porc_entrada: null, qtd_dias: null,
        tipo_baixa: null, juros: null, indicemonetario_id: null,
        multa: null, indice_monetaria: null, type_valor_honorario: null,
        valor_honorario: null, type_outros: null, outros: null,
        descricao_outros: null, data_final_vigiencia: null,
        permite_negociacao_agrupada: false,
        prioridade: 0,
        elegibilidade: elegibilidadeVazia(),
      };
    },
    _carregarItem(item) {
      this.hand.id                          = item.id;
      this.hand.nome_regra                  = item.nome_regra;
      this.hand.data_vigiencia              = item.data_vigiencia;
      this.hand.descricao                   = item.descricao;
      this.hand.pagamento_parcelado         = item.pagamento_parcelado;
      this.hand.qtd_parcelas                = item.qtd_parcelas;
      this.hand.desconto_avista             = item.desconto_avista;
      this.hand.porc_entrada                = item.porc_entrada;
      this.hand.qtd_dias                    = item.qtd_dias;
      this.hand.tipo_baixa                  = item.tipo_baixa;
      this.hand.juros                       = item.juros;
      this.hand.multa                       = item.multa;
      this.hand.indicemonetario_id          = item.indicemonetario_id;
      this.hand.indice_monetaria            = item.indice_monetaria;
      this.hand.type_valor_honorario        = item.type_valor_honorario;
      this.hand.valor_honorario             = item.valor_honorario;
      this.hand.type_outros                 = item.type_outros;
      this.hand.outros                      = item.outros;
      this.hand.descricao_outros            = item.descricao_outros;
      this.hand.data_final_vigiencia        = item.data_final_vigiencia;
      this.hand.permite_negociacao_agrupada = !!item.permite_negociacao_agrupada;
      this.hand.prioridade                  = item.prioridade || 0;

      if (item.elegibilidade) {
        this.hand.elegibilidade = { ...elegibilidadeVazia(), ...item.elegibilidade };
      } else {
        this.hand.elegibilidade = elegibilidadeVazia();
      }
    },
    getIndicesMonetarios() {
      this.$http.get("indicess_monetarios").then(
        (response) => { this.indices_monetarios = response.data; },
        (response) => { console.log(response); }
      );
    },
    getAcordos() {
      this.$http.get("AcordoCrud").then(
        (response) => { this.list = response.data; },
        (response) => { console.log(response); }
      );
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.carregando = true;
        if (this.modal.type === "novo") this.criarAcordo();
        else if (this.modal.type === "editar") this.editarAcordo();
      }
    },
    abrirModalNovo() {
      this.limparForm();
      this.abaAtiva    = 0;
      this.modal.title = "Nova Configuração de Acordo";
      this.modal.type  = "novo";
      this.carregando  = false;
      this.isReadOnly  = false;
      this.dialog      = true;
      this.$refs.form && this.$refs.form.resetValidation();
    },
    abrirModalVer(item) {
      this.limparForm();
      this._carregarItem(item);
      this.abaAtiva    = 0;
      this.modal.title = "Configuração do Acordo";
      this.modal.type  = "editar";
      this.carregando  = false;
      this.isReadOnly  = true;
      this.dialog      = true;
    },
    abrirModalEditar(item) {
      this.limparForm();
      this._carregarItem(item);
      this.abaAtiva    = 0;
      this.modal.title = "Editar Configuração do Acordo";
      this.modal.type  = "editar";
      this.carregando  = false;
      this.isReadOnly  = false;
      this.dialog      = true;
    },
    abrirModalInativar(data) {
      this.hand.id         = data.id;
      this.hand.nome_regra = data.nome_regra;
      this.carregando      = false;
      this.modalDelete     = true;
    },
    _payload() {
      return {
        nome_regra:                   this.hand.nome_regra,
        data_vigiencia:               this.hand.data_vigiencia,
        descricao:                    this.hand.descricao,
        pagamento_parcelado:          this.hand.pagamento_parcelado ? "1" : "0",
        qtd_parcelas:                 this.hand.qtd_parcelas,
        desconto_avista:              this.hand.desconto_avista,
        porc_entrada:                 this.hand.porc_entrada,
        qtd_dias:                     this.hand.qtd_dias,
        tipo_baixa:                   this.hand.tipo_baixa,
        juros:                        this.hand.juros,
        multa:                        this.hand.multa,
        indice_monetaria:             this.hand.indice_monetaria,
        indicemonetario_id:           this.hand.indicemonetario_id,
        type_valor_honorario:         this.hand.type_valor_honorario ? "1" : "0",
        valor_honorario:              this.hand.valor_honorario,
        type_outros:                  this.hand.type_outros ? "1" : "0",
        outros:                       this.hand.outros,
        descricao_outros:             this.hand.descricao_outros,
        data_final_vigiencia:         this.hand.data_final_vigiencia,
        permite_negociacao_agrupada:  this.hand.permite_negociacao_agrupada ? "1" : "0",
        prioridade:                   this.hand.prioridade || 0,
        elegibilidade:                this.hand.elegibilidade,
      };
    },
    criarAcordo() {
      this.$http.post("AcordoCrud", { ...this._payload(), is_stone: 1 }).then(
        (response) => {
          this.getAcordos(); this.dialog = false;
          this.$refs.form.resetValidation();
          this.notificacao("", response.body.message, "success");
          this.carregando = false;
        },
        (response) => {
          this.dialog = false;
          this.$refs.form.resetValidation();
          this.notificacao("", response.body.message, "error");
          this.carregando = false;
        }
      );
    },
    editarAcordo() {
      this.$http.put("AcordoCrud/" + this.hand.id, this._payload()).then(
        (response) => {
          this.getAcordos(); this.dialog = false;
          this.$refs.form.resetValidation();
          this.notificacao("", response.body.message, "success");
          this.carregando = false;
        },
        (response) => {
          this.dialog = false;
          this.$refs.form.resetValidation();
          this.notificacao("", response.body.message, "error");
          this.carregando = false;
        }
      );
    },
    inativarConf() {
      this.carregando = true;
      this.$http.delete("AcordoCrud/" + this.hand.id).then(
        (response) => {
          this.getAcordos(); this.modalDelete = false;
          this.notificacao("", response.body.message, "success");
        },
        (response) => {
          this.modalDelete = false;
          this.notificacao("", response.body.message, "error");
        }
      );
    },
    getDataFinal(data) { this.hand.data_final_vigiencia = data; },

    elegibilidadeResumo(eleg) {
      if (!eleg) return '';
      const partes = [];
      if (eleg.ufs_elegiveis && eleg.ufs_elegiveis.length)
        partes.push(eleg.ufs_elegiveis.join(', '));
      if (eleg.valor_minimo || eleg.valor_maximo) {
        const min = eleg.valor_minimo ? `R$ ${Number(eleg.valor_minimo).toLocaleString('pt-BR')}` : '∞';
        const max = eleg.valor_maximo ? `R$ ${Number(eleg.valor_maximo).toLocaleString('pt-BR')}` : '∞';
        partes.push(`${min}–${max}`);
      }
      if (eleg.dias_atraso_min || eleg.dias_atraso_max) {
        const dMin = eleg.dias_atraso_min ?? '∞';
        const dMax = eleg.dias_atraso_max ?? '∞';
        partes.push(`${dMin}–${dMax} dias`);
      }
      return partes.join(' · ') || 'Configurado';
    },
  },
};
</script>

<style scoped>
.acordos-page {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }

.form-section__header {
  display: flex; align-items: center; gap: 12px; flex-wrap: wrap;
}
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }

/* ── Dialog ── */
.dialog-header {
  display: flex; align-items: center; gap: 14px;
  padding: 20px 24px 16px; border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 38px; height: 38px; background: #e8f0fe; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.dialog-header__icon-wrap--danger { background: #fef2f2; }
.dialog-header__title { font-family: 'Inter', sans-serif; font-size: 1rem; font-weight: 700; color: #1e293b; }
.dialog-header__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; }

.dialog-section-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem; font-weight: 700; color: #94a3b8;
  text-transform: uppercase; letter-spacing: 0.8px;
  margin-bottom: 10px;
}

/* ── Tabs ── */
.acordos-tabs { border-bottom: 1px solid #f1f5f9; }
.tab-label {
  font-family: 'Inter', sans-serif !important;
  font-size: 0.78rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
}

/* ── Cards ── */
.negociacao-agrupada-card {
  border: 1px solid #e8f0fe !important;
  border-radius: 10px !important;
  background: #f8fbff !important;
}
.negociacao-agrupada-icon {
  width: 40px; height: 40px; background: #e8f0fe; border-radius: 10px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.canal-card {
  border: 1px solid #f1f5f9 !important;
  border-radius: 10px !important;
  background: #fafafa !important;
}

/* ── Tabela ── */
.acordos-table >>> th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; padding: 10px 12px !important; white-space: nowrap;
}
.acordos-table >>> td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  padding: 10px 12px !important; border-bottom: 1px solid #f1f5f9 !important;
}
.text-res {
  max-width: 280px; overflow: hidden;
  text-overflow: ellipsis; white-space: nowrap;
}
.eleg-chip-wrap >>> .v-chip { max-width: 200px; overflow: hidden; text-overflow: ellipsis; }

.acordos-page >>> .v-input__slot { background-color: #fff !important; box-shadow: none !important; }
.acordos-page >>> .v-label { font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important; }

@media (max-width: 768px) { .acordos-page { padding: 16px; } }
@media (max-width: 600px) {
  /* ícone + título na 1ª linha, busca na 2ª, botão na 3ª */
  .form-section__heading { flex: 1 1 0; min-width: 0; }
  .form-section__header > .spacer { display: none; }
  .acordos-busca { max-width: none !important; flex: 1 1 100%; margin-right: 0 !important; }
}
</style>
